module.exports = __webpack_public_path__ + "static/media/contact.8ba361cc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resource/contact.svg
// module id = 295
// module chunks = 0